module.exports = __webpack_public_path__ + "img/IMG_0577_8_9_L_BlackMatted_MockedUp.4cf5d8df.jpg";